export const TOKEN_KEY = 'dcrym';
export const STSTEM_STATE_KEY = 'dcrym-state';
export const SUCCESS_CODE = 1000;
export const LOGOUT_CODE = -2;

export const selectTypeMapping = [
  { label: '赠送类型', value: '2' },
  { label: '消费类型', value: '3' },
  { label: '支付方式', value: '4' },
  { label: '支付类型', value: '5' },
  { label: '业务功能', value: '7' },
];

export const customerStateOptions = [
  { value: '1', label: '正常' },
  { value: '2', label: '锁定' },
];

export const customerTypesOptions = [
  { label: '学生', value: '1' },
  { label: '学生01', value: '9' },
  { label: '学生02', value: '10' },
  { label: '学生03', value: '11' },
  { label: '学生04', value: '12' },
  { label: '学生05', value: '13' },
  { label: '学生(无广告)', value: '14' },
  { label: '教师', value: '2' },
  { label: '职工', value: '3' },
  { label: '群众', value: '4' },
  { label: '社区领导', value: '5' },
  { label: '学校领导', value: '6' },
  { label: '单位领导', value: '7' },
  { label: '培训人员', value: '8' },
];

export const customerSexOptions = [
  { label: '男', value: '1' },
  { label: '女', value: '2' },
];

export const customerIsFirstRechargeOptions = [
  { label: '未充值', value: '0' },
  { label: '已充值', value: '1' },
];

export const areaTypes = [
  { label: '停止运营', value: '0' },
  { label: '正常运营', value: '1' },
  { label: '测试使用', value: '2' },
];

export const properties = [
  { label: '学校', value: '1' },
  { label: '单位', value: '2' },
  { label: '社区', value: '3' },
];

export const operClassifyList = [
  { label: '新增', value: '01' },
  { label: '修改', value: '02' },
  { label: '删除', value: '03' },
  { label: '开启', value: '04' },
  { label: '关闭', value: '05' },
  { label: '模式修改', value: '06' },
];
//角色操作记录
export const operClassifyName4role = [
  { label: '新增', value: '01' },
  { label: '修改', value: '02' },
  { label: '锁定', value: '03' },
  { label: '解锁', value: '04' },
  { label: '绑定用户', value: '05' },
  { label: '授权', value: '06' },
];

//用户操作记录
export const operClassifyName4User = [
  { label: '重置密码', value: '01' },
  { label: '修改', value: '02' },
  { label: '锁定', value: '03' },
  { label: '解锁', value: '04' },
  { label: '新增', value: '05' },
 
];

export const serviceMap = [
  { label: '艾米', value: '0' },
  { label: '通用', value: '1' },
  { label: '洗衣', value: '2' },
  { label: '饮水', value: '3' },
  { label: '吹风', value: '4' },
  { label: '洗浴', value: '5' },
];

export default {
  selectTypeMapping,
  customerStateOptions,
  customerTypesOptions,
  customerSexOptions,
  customerIsFirstRechargeOptions,
  areaTypes,
  properties,
  operClassifyList,
  operClassifyName4role,
  operClassifyName4User,
};
